export type ApiResponse<T = {}> = {
  error: boolean;
  error_code: string;
  message?: string;
} & T;

export type PaginatedData = {
  totalDocs: number;
  limit: number;
  totalPages: number;
  page: number;
  pagingCounter: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
};

export type ApiPaginatedResponse<T> = PaginatedData & ApiResponse<T>;

export interface ReactQuerySuccessAndFailHooks<
  DataType,
  SuccessReturnType = void,
  ErrorReturnType = void
> {
  onSuccessCallback?: (data?: DataType) => SuccessReturnType;
  onErrorCallback?: (error?: any) => ErrorReturnType;
}

export class ApiError extends Error {
  public error_code?: string;

  public data?: any;

  constructor(message: string, data?: any, errorCode?: string) {
    super(message);
    this.name = 'ApiError';
    this.data = data;
    this.error_code = errorCode;
  }
}